export var EVENTS = {
	REFRESH_GRID: 'REFRESH_GRID',
	LINK_BOOK_RECORD: 'LINK_BOOK_RECORD'
}